<template lang="pug">
v-navigation-drawer(
  v-model="drawer"
  :mini-variant="isMini"
  mini-variant-width="96"
  width="280"
  floating
  permanent
  app
)
  div.mx-4.mb-4.navigation
    router-link(:to="access('guestUser') ? '/create-account' : '/'")
      div.mt-8.mb-6.text-center
        img(:src="isMini ? LogoMini : Logo")
    div.navigation-lists
      v-list(nav dense elevation="0").pa-0.ma-0.w-full
        v-list-item(
          v-for="(item, i) in menu"
          :key="i"
          :to="item.path"
          active-class="menu-active"
          :exact="item.exact"
          :class="isMini && 'pl-6'"
        ).py-3.pr-6
          div(class="menu-icon" :class="{'mr-4': !isMini}")
            img.image(
              :src="item.icon"
            )
          v-list-item-content.pt-0.pb-0.menu-list-item-content {{ item.key ? $t(item.key) : item.text }}
            v-list-item-subtitle(v-if="item.subtitle" ) ({{ $t(item.subtitle) }})
          v-chip(
            v-if="item.counter && getCounter(item.counter)"
            small
            color="green"
            text-color="white"
            ) {{ getCounter(item.counter) }}
      div.py-10
      v-list(nav dense elevation="0").pa-0.ma-0.w-full
        TechSupportButton
        v-list-item(
          v-for="(item, i) in menu2"
          :key="i"
          :to="item.path"
          active-class="menu-active"
          :class="isMini && 'pl-6'"
        ).py-3.pr-6
          div(:class="{'mr-4': !isMini}").menu-icon
            img.image(:src="item.icon")
          v-list-item-content(v-if="!isMini" ) {{ item.key ? $t(item.key) : item.text }}

        v-list-item(
          @click="isMini = !isMini"
          :class="isMini && 'pl-6'"
        ).py-3.pr-6
          div(:class="{'mr-4': !isMini}").menu-icon
            img.image(:src="isMini ? ArrowRight : ArrowLeft")
          v-list-item-content(v-if="!isMini" ) {{ $t('close') }}

</template>
<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import Logo from '@/assets/logo.svg'
import LogoMini from '@/assets/logo-mini.svg'
import Check from '@/assets/icons/check.svg'
import Chart from '@/assets/icons/chart.svg'
import Flag from '@/assets/icons/flag.svg'
import Cog from '@/assets/icons/cog.svg'
import ArrowRight from '@/assets/icons/arrow-right.svg'
import ArrowLeft from '@/assets/icons/arrow-left.svg'
import { access } from '@/configs/permissions'

import Home from '@/assets/icons/menu-home.svg'
import Certification from '@/assets/icons/menu-certification.svg'
import CertificationSign from '@/assets/icons/menu-certification-sign.svg'
import Measurement from '@/assets/icons/menu-measurement.svg'
import Otk from '@/assets/icons/menu-otk.svg'
import newManual from '@/assets/icons/car-outline.svg'
import TechSupportButton from '@/components/TechSupport/TechSupportButton.vue'

export default {
  components: {
    TechSupportButton
  },
  data () {
    return {
      access,
      Logo,
      LogoMini,
      Check,
      Chart,
      Home,
      Flag,
      Cog,
      ArrowRight,
      ArrowLeft,
      drawer: null,
      menu: [],
      menu2: []
    }
  },
  computed: {
    ...mapGetters(['getCounters']),
    ...mapState({
      isMiniApp: state => state.app.isMini,
      profile: state => state.profile.profile,
      isActiveProfile: state => state.profile.isActiveProfile,
      counterClientStatement: state => state.statement.counterClientStatement,
    }),
    isMini: {
      get () {
        return this.isMiniApp
      },
      set (value) {
        this.SET_DATA({ store: 'app', state: 'isMini', data: value })
      }
    }
  },

  async mounted () {
      access('statementActionDirectorCertification') &&
      this.menu.push({ path: '/cabinet/statistics/authorities-certificate', key: 'menu.cabinet', icon: Home })
      access('branchView') && this.menu.push({ path: '/laboratory', key: 'menu.branches', icon: Home })

    if (!access('guestUser') && this.isActiveProfile) {
      (access('clientStatementView') || access('clientTechnicalControlView')) && await this.getCounterClientStatement()
      access('statementView') && this.menu.push({
          path: '/statements',
          key: 'menu.statements',
          icon: Certification,
          exact: true
        },
      )
      if (access('clientStatementView') && (process.env.VUE_APP_MODE_STG || process.env.VUE_APP_MODE_TEST)) {
        this.menu.push(
          {
            path: '/client-statements-certificate',
            key: 'menu.newCertification',
            counter: this.counterClientStatement.new_client_statements_certification,
            icon: Certification
          }
        )
      }
      access('statementView') &&
        this.menu.push({
          path: '/statements?can_sign=true',
          key: 'menu.certificationForSign',
          icon: CertificationSign,
          exact: true,
          counter: 'statement_for_certifications'
        })

      if (access('statementNewKtz') && process.env.VUE_APP_MODE_TEST) {
        this.menu.push({
          path: '/statements-manual',
          key: 'menu.certificationManual',
          icon: newManual,
          subtitle: 'menu.certificationManualSubtitle'
        })
      }

      access('technicalControlView') &&
      this.menu.push(
        {
          path: '/technical-control/statement',
          key: 'menu.techControl',
          icon: Otk
        },
      )
      if (access('clientTechnicalControlView') && (process.env.VUE_APP_MODE_STG || process.env.VUE_APP_MODE_TEST)) {
        this.menu.push(
          {
            path: '/client-technical-control/statement',
            key: 'menu.newTechnicalControl',
            counter: this.counterClientStatement.new_client_statements_mti,
            icon: Otk
          }
        )
      }
      access('reEquipmentView') && this.menu.push({
        path: '/measurements',
        key: 'menu.measurements',
        icon: Measurement
      })
      access('settings') && this.menu2.push({ path: '/settings/account', key: 'menu.settings', icon: Cog })
    }
  },
  methods: {
    ...mapMutations(['SET_DATA']),
    ...mapActions(['getCounterClientStatement']),
    getCounter(counter) {
      return this.getCounters?.statements?.[counter]?.length
    }
  }
}
</script>

<style lang="sass" scoped>
.navigation
  display: flex
  flex-flow: column
  height: 100%
  &-lists
    display: flex
    flex-flow: column
    justify-content: space-between
    height: 100%
    overflow-y: auto
    overflow-x: hidden
.menu-list-item-content
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%
</style>
